<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import { TemperatureWheel } from '@Shelly/shelly-design-system';
	//Helpers
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Types
	import type { Device } from 'src/types/Device';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device, statuses: VCInterfaceStatus[];

	let waitForTargetTempResponse = false;
	let sendTimeout: NodeJS.Timeout;
	let targetLock = false;
	let targetValue: number = null;

	const a11yProps = {
		tempWheelAriaLabel: $format('label_temperature', { default: 'Temperature' }),
		thumbAriaLabel: $format('label_temperature_thumb', { default: 'Temperature thumb' }),
		incrementBtnAriaLabel: $format('button_increase_temperature', {
			default: 'Increase temperature',
		}),
		decrementBtnAriaLabel: $format('button_decrease_temperature', {
			default: 'Decrease temperature',
		}),
	};

	const onChange = async (e: CustomEvent) => {
		targetLock = true;
		targetValue = e.detail.value;
		clearTimeout(sendTimeout);
		sendTimeout = setTimeout(sendChange, 1000, e.detail.value);
	};

	const sendChange = async (value: number) => {
		waitForTargetTempResponse = true;
		const res: SettingRequest = await gen2Request(device, 'Number.set', {
			id: target.id,
			value,
		});
		if (!res.isok) {
			targetLock = false;
			onChangeTargetValue(target?.event);
		}
		waitForTargetTempResponse = false;
	};

	const onChangeTargetValue = (value: number) => {
		if (targetValue == value) targetLock = false;
		if (value != null && !targetLock && targetValue != value) {
			targetValue = value;
		}
	};

	$: target = statuses.find((i) => i.role == 'target_temperature');
	$: current = statuses.find((i) => /^(current_temperature|curr_temperature)$/.test(i.role));
	$: onChangeTargetValue(target?.event);
</script>

{#if target}
	<TemperatureWheel
		class="mb-l text-center"
		{a11yProps}
		valuePrefix={target.unit}
		value={targetValue}
		current={{
			value: current?.value || 0,
			description: $format('xt1_template_current_temperature', {
				default: 'Current temperature',
			}),
		}}
		min={target.min ?? 0}
		max={target.max ?? 100}
		step={target.step || 1}
		type={'temp'}
		icon={'fas fa-temperature-three-quarters'}
		isLoading={waitForTargetTempResponse}
		on:value_change={onChange}
	/>
{/if}
